import { DELAY_UNITS, SMART_DELAY_UNITS, TYPING_UNITS } from './flowConstants';

export function toDelaySeconds(value, unit) {
  const raw = Number(value);
  if (!Number.isFinite(raw) || raw <= 0) return 0;
  const factor = DELAY_UNITS.find((u) => u.value === unit)?.factor || 1;
  return raw * factor;
}

export function fromDelaySeconds(seconds) {
  const raw = Number(seconds);
  if (!Number.isFinite(raw) || raw <= 0) {
    return { value: '', unit: 'seconds' };
  }

  const byLargest = [...DELAY_UNITS].sort((a, b) => b.factor - a.factor);
  for (const unit of byLargest) {
    if (raw % unit.factor === 0) {
      return { value: raw / unit.factor, unit: unit.value };
    }
  }

  return { value: raw, unit: 'seconds' };
}

export function toTypingSeconds(value, unit) {
  const raw = Number(value);
  if (!Number.isFinite(raw) || raw <= 0) return 0;
  const factor = TYPING_UNITS.find((u) => u.value === unit)?.factor || 1;
  return raw * factor;
}

export function fromTypingSeconds(seconds) {
  const raw = Number(seconds);
  if (!Number.isFinite(raw) || raw <= 0) {
    return { value: '', unit: 'seconds' };
  }

  const byLargest = [...TYPING_UNITS].sort((a, b) => b.factor - a.factor);
  for (const unit of byLargest) {
    if (raw % unit.factor === 0) {
      return { value: raw / unit.factor, unit: unit.value };
    }
  }

  return { value: raw, unit: 'seconds' };
}

export function toSmartDelaySeconds(value, unit) {
  const raw = Number(value);
  if (!Number.isFinite(raw) || raw <= 0) return 0;
  const factor = SMART_DELAY_UNITS.find((u) => u.value === unit)?.factor || 1;
  return raw * factor;
}

export function getSmartDelayDisplay(minSeconds, maxSeconds) {
  let minRaw = Number(minSeconds);
  let maxRaw = Number(maxSeconds);

  if (!Number.isFinite(minRaw) || !Number.isFinite(maxRaw) || minRaw <= 0 || maxRaw <= 0) {
    return { minValue: '', maxValue: '', unit: 'seconds' };
  }

  if (maxRaw < minRaw) {
    const tmp = minRaw;
    minRaw = maxRaw;
    maxRaw = tmp;
  }

  const useMinutes = minRaw % 60 === 0 && maxRaw % 60 === 0;
  const unit = useMinutes ? 'minutes' : 'seconds';
  const factor = SMART_DELAY_UNITS.find((u) => u.value === unit)?.factor || 1;

  return {
    minValue: minRaw / factor,
    maxValue: maxRaw / factor,
    unit,
  };
}
